import { defineMessages } from 'react-intl';

export default defineMessages({
  error: 'Transaction amount is incorrect',
});
